// Text duration field for bulk-edit, using parseDurationInput and formatHours display.
import { TextField } from '@mui/material';
import { translate as t } from '@/i18n/useT';
import { parseDurationInput } from '@/utils/timeUtils';
import { formatHours } from '@/components/ui/formatHours';
import { BulkEditFieldGroup } from './BulkEditFieldGroup';
import { isDurationFieldInvalid } from './taskBulkEditDurationUtils';

const BULK_EDIT_DURATION_ID = 'bulk-edit-duration';

const formatBulkDurationDisplay = (minutes) =>
  minutes || minutes === 0 ? formatHours(minutes / 60) : '';

export function BulkEditDurationField({
  duration,
  setDuration,
  untouchedSymbol,
}) {
  const durationInvalid = isDurationFieldInvalid(duration, untouchedSymbol);

  return (
    <BulkEditFieldGroup
      label={t('taskbulkeditmodal.duration', 'Duration')}
      htmlFor={BULK_EDIT_DURATION_ID}
    >
      <TextField
        id={BULK_EDIT_DURATION_ID}
        type="text"
        value={duration === untouchedSymbol ? '' : duration}
        onChange={(e) => setDuration(e.target.value)}
        onBlur={() => {
          if (duration === untouchedSymbol || duration === '') return;
          const parsed = parseDurationInput(duration);
          if (parsed !== null) {
            setDuration(formatBulkDurationDisplay(parsed));
          }
        }}
        error={durationInvalid}
        helperText={
          durationInvalid
            ? t(
                'taskbulkeditmodal.durationInvalid',
                'Invalid duration; try e.g. 30m, 1h, or 1u30',
              )
            : duration === untouchedSymbol
              ? t('taskbulkeditmodal.noChange', "Don't change")
              : ''
        }
        fullWidth
      />
    </BulkEditFieldGroup>
  );
}
